app.header = {
	// COMMON --------------------------------------------
	// Configs + Constants
	TIMERS: '',
	DATA: '',
	AJAX: '',
	

	// MAIN FUNCTIONS ------------------------------------
	init: function () {
		console.log('-- app.header.init --');

		this.setupLayout();
		this.setupEvents();
	},

	setupEvents: function() {

		$_this = this;

		$doc
			.on('click', '.js-toggleFakeSelect', this.selectBox.toggle)
			.on('click', '.js-fakeSelect a', this.selectBox.select)

			.on('click', '.js-subMenu a', this.subMenu.toggle)

			.on('click', '.js-fullMenuOpen', this.fullMenu.open)
			.on('click', '.js-fullMenuClose', this.fullMenu.close)

			.on('click', '.js-fullMenu nav a', this.fullMenu.toggleChild)

			.on('click', '.js-layerSearchToggle', this.layerSearch.toggleOpen)
			.on('click', '.js-toggleSearchType', this.layerSearch.toggleType)

			.on('click', '.module-layer-search', function(e) {
				if (this != e.target) {
					return;
				}
				$_this.layerSearch.toggleOpen();
			})

			.on('backbutton', function(e) {
				if ($_this.fullMenu.isOpen()) {
					$_this.fullMenu.close();
				}
				if ($_this.layerSearch.isOpen()) {
					$_this.layerSearch.toggleOpen();
				} 
			});

		$doc
			.keyup(function(e) {
				if (e.key === "Escape") {
					if ($_this.fullMenu.isOpen()) {
						$_this.fullMenu.close();
					}
					if ($_this.layerSearch.isOpen()) {
						$_this.layerSearch.toggleOpen();
					} 

				}
			});
				
	},
	setupLayout: function () {},

	// OTHER FUNCTIONS -----------------------------------
	selectBox: {
		events: {
			on: function(){
				$doc
					.on('click.selectBox', function(e){
						console.log('click on');
						if (!$(e.target).closest('.js-fakeSelect').length) {
							var $dropdown = $('.js-fakeSelect');
							$dropdown.removeClass('is-open');
							app.header.selectBox.events.off();
						}
					});
			},
			off: function(){
				$doc
					.off('click.selectBox');
			}
		},
		select: function(){
			var $el = $(this),
				$dropdown = $el.closest('.js-fakeSelect');

			$dropdown.find('.ae-select-content').text($el.text());
			$dropdown.find('.dropdown-menu > li').removeClass('selected');

			$dropdown.removeClass('is-open');
			app.header.selectBox.events.off();
		},
		toggle: function(){
			console.log('click');
			var $el = $(this),
				$dropdown = $el.closest('.js-fakeSelect');

			$dropdown.toggleClass('is-open');
			if($dropdown.hasClass('is-open')){
				app.header.selectBox.events.on();
			}
			else{
				app.header.selectBox.events.off();
			}
		}
	},

	subMenu: {
		toggle: function(){
			var $el = $(this),
				$li = $el.closest('li'),
				$sub = $li.find('.level-2');

			if(app.helpers.isElement($sub)){
				if (!$li.hasClass('current_page_item')) {
					$li.toggleClass('current_page_item');
				}
			}
		}
	},

	fullMenu: {
		open: function(){
			var $menu = $body.find('.js-fullMenu');
			$menu.addClass('is-open');
			$body
				.addClass('is-stopScrolling')
				.addClass('menu-is-open');
		},

		isOpen: function(){
			var $menu = $body.find('.js-fullMenu');
			if ($menu.hasClass('is-open')) {
				return true;
			}
			return false;
		},

		close: function(){
			var $menu = $body.find('.js-fullMenu');
			$menu.removeClass('is-open');
			if (!$('.module-layer-search').hasClass('is-open')) {
				$body.removeClass('is-stopScrolling');
			}
			$body.removeClass('menu-is-open');
		},

		toggleChild: function(e){
			var $el = $(this);
			
			if($el.hasClass('is-open')){
				if (app.isMobile()) {
					e.preventDefault();
				}

				$el.toggleClass('is-open');

				$el.closest('li').find('ul.level-1.is-open').removeClass('is-open');
			}
			else {
				$el.toggleClass('is-open');

				if ($el.closest('li').find('ul').length) {
					if (app.isMobile()) {
						e.preventDefault();
					}
					$el.closest('li').find('> ul').addClass('is-open');
				}
				else {
					if ($el.hasClass('js-goBack')) {
						$el.closest('ul')
							.removeClass('is-open')
							.find('ul')
							.removeClass('is-open');

						$el.closest('.is-open').removeClass('is-open');
						$el.closest('li').closest('ul').closest('li').find('a.is-open').removeClass('is-open');
					}
				}
			}

			if(app.isMobile()){
				if($el.hasClass('level-1-a')){
					if($el.hasClass('is-open')){
						$el.closest('ul').addClass('is-open');
					}
					else{
						$el.closest('ul').removeClass('is-open');
					}
				}
			}
		}
	},

	layerSearch: {
		toggleOpen: function(){
			$('.module-layer-search').toggleClass('is-open');
			$body.toggleClass('is-stopScrolling');
		},
		toggleType: function(){
			var $el = $(this),
				type = $el.data('type'),
				$row = $el.closest('.form-row'),
				$form = $el.closest('form');

			$row.find('.btn').removeClass('is-active');
			$el.addClass('is-active');

			$row.find('input[name="search-type"]').val(type);
			$form.find('.form-search').removeClass('is-disabled');
			$form.find('.form-search [disabled]').prop('disabled', false);
		},
		isOpen: function() {
			if($('.module-layer-search').hasClass('is-open')) {
				return true;
			}
			return false;
		}
	}
};
